module.exports = __webpack_public_path__ + "files/12c72cb0c052c87aa9f970bfdae98332.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/arvo-bold-webfont.svg
 ** module id = 884
 ** module chunks = 0
 **/